<script>
    import Box from "./Elements/Box.svelte";
    import {onMount} from "svelte";
    import gsap from "gsap";
    import {labels, mainTimeline} from "../timelines/main-timeline";
    import MotionPathPlugin from 'gsap/MotionPathPlugin';
    import isSafari from "../helpers/isSafari";

    export let scene = 0;

    gsap.registerPlugin(MotionPathPlugin);

    let timer;
    let width = window.innerWidth;

    const debounce = () => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            width = window.innerWidth;
        }, 500);
    }

    window.addEventListener("resize", debounce)

    function getSafariScale(width) {
        return width < 1920 ? width / 1920 : 0.625;
    }

    $: multiplier = !isSafari() ? 1 : getSafariScale(width);

    const timeline = gsap.timeline();

    const {
        gnosisStart,
        gnosisEnd,
        telescopeEnd,
        lighthouseEnd,
        leadersEnd,
        magnifyingGlassEnd,
        threeLeadersEnd,
        buildingEnd,
        circleEnd,
        circleStart,
    } = labels;

    const pathEnd = 'pathEnd+=3';

    const circleEndVariance = 3.33333;

    // This function lets me input data taken from After Effects and
    // mutate it into something that works in the browser
    const positionBox = (x, y) => ({
        x: x * 1 - 190,
        y: y * 1.4 - 490,
    });

    let boxPosition = 0;

    let boxData = [
        positionBox(653, 560),
        positionBox(1267, 561),
        positionBox(653, 710),
        positionBox(1269, 729),
        positionBox(383, 439),
        positionBox(296, 520),
        positionBox(173, 560),
        positionBox(341, 667),
        positionBox(276, 825),
        positionBox(117, 848),
    ];


    let activeTimes = [
        [['gnosisStart', 'gnosis0'], ['buildingEnd', 'circleEnd']],
        [['gnosis0', 'gnosis1'], ['telescopeStart', 'telescope0'], ['path1', 'threeLeadersStart'], ['threeLeaders1', 'threeLeaders2'], ['buildingEnd', 'gnosisFinalStart']],
        [['gnosis1', 'gnosis2'], ['lighthouseStart+=1', 'lighthouseEnd'], ['pathStart', 'threeLeaders0'], ['magnifyingGlassStart', 'threeLeaders0'], ['buildingEnd', 'gnosisFinalStart']],
        [['gnosis2', 'gnosis3'], ['telescope0', 'telescope1'], ['buildingEnd', 'gnosisFinalStart']],
        [['buildingEnd', 'gnosisFinalStart']],
        [['buildingEnd', 'circleEnd']],
        [['buildingEnd', 'gnosisFinalStart']],
        [['path0', 'threeLeadersStart'], ['threeLeaders0', 'threeLeaders1'], ['buildingEnd', 'gnosisFinalStart']],
        [['buildingEnd', 'gnosisFinalStart']],
        [['buildingEnd', 'gnosisFinalStart']],
    ];

    let spinningTimes = [
        [['gnosisStart', 'gnosis0'], ['buildingEnd', 'circleEnd']],
        [['gnosis0', 'gnosis1'], ['telescopeStart', 'telescope0'], ['threeLeaders1', 'threeLeaders2'], ['buildingEnd', 'gnosisFinalStart']],
        [['gnosis1', 'gnosis2'], ['lighthouseStart+=1', 'lighthouseEnd'], ['magnifyingGlassStart', 'threeLeaders0'], ['buildingEnd', 'gnosisFinalStart']],
        [['gnosis2', 'gnosis3'], ['telescope0', 'telescope1'], ['buildingEnd', 'gnosisFinalStart']],
        [['buildingEnd', 'gnosisFinalStart']],
        [['buildingEnd', 'circleEnd']],
        [['buildingEnd', 'gnosisFinalStart']],
        [['threeLeadersStart', 'threeLeaders1'], ['buildingEnd', 'gnosisFinalStart']],
        [['buildingEnd', 'gnosisFinalStart']],
        [['buildingEnd', 'gnosisFinalStart']],
    ];

    let liftTimes = [
        [['gnosisStart', 'gnosis0'], ['circleStart', 'gnosisFinalEnd']],
        [['gnosis0', 'gnosis1'], ['telescopeStart', 'telescope0'], ['circleStart', 'gnosisFinalEnd']],
        [['gnosis1', 'gnosis2'], ['lighthouseStart+=1', 'lighthouseEnd'], ['circleStart', 'gnosisFinalEnd']],
        [['gnosis2', 'gnosis3'], ['telescope0', 'telescope1'], ['circleStart', 'gnosisFinalEnd']],
        [['circleStart', 'gnosisFinalEnd']],
        [['circleStart', 'gnosisFinalEnd']],
        [['circleStart', 'gnosisFinalEnd']],
        [['circleStart', 'gnosisFinalEnd']],
        [['circleStart', 'gnosisFinalEnd']],
        [['circleStart', 'gnosisFinalEnd']],
    ];

    let stopSpinScenes = [
        [],
        [7, 8],
        [7, 8],
        [],
        [],
        [],
        [],
        [7, 8],
        [],
        [],
    ];

    let clickableScenes = [
        [3],
        [3, 4, 7, 9],
        [3, 5, 7, 9],
        [3, 4],
        [],
        [],
        [],
        [7, 9],
        [],
        [],
    ];

    let boxMoves = [
        //gnosisEnd,
        [
            positionBox(584, 574),
            positionBox(1297, 606),
            positionBox(603, 717),
            positionBox(1309, 799),
            positionBox(1259, 429),
            positionBox(700, 392),
            positionBox(105, 423),
            positionBox(266, 532),
            positionBox(376, 615),
            positionBox(44, 718),
        ],
        //telescopeEnd,
        [
            positionBox(278, 748),
            positionBox(1297, 606),
            positionBox(611, 545),
            positionBox(1309, 799),
            positionBox(434, 462),
            positionBox(423, 710),
            positionBox(105, 423),
            positionBox(266, 532),
            positionBox(376, 615),
            positionBox(44, 718),
        ],
        //lighthouseEnd,
        [
            positionBox(113, 865),
            positionBox(377, 446),
            positionBox(485, 392),
            positionBox(351, 679),
            positionBox(313, 413),
            positionBox(297, 841),
            positionBox(105, 423),
            positionBox(176, 575),
            positionBox(376, 615),
            positionBox(206, 706),
        ],
        //leadersEnd,
        [
            positionBox(113, 865),
            positionBox(1230, 670),
            positionBox(1068, 825),
            positionBox(351, 679),
            positionBox(313, 413),
            positionBox(297, 841),
            positionBox(105, 423),
            positionBox(840, 610),
            positionBox(376, 615),
            positionBox(206, 706),
        ],
        //pathEnd,
        [
            positionBox(113, 865),
            positionBox(1065, 640),
            positionBox(895, 640),
            positionBox(351, 679),
            positionBox(313, 413),
            positionBox(297, 841),
            positionBox(105, 423),
            positionBox(980, 660),
            positionBox(376, 615),
            positionBox(206, 706),
        ],
        //magnifyingGlassEnd,
        [
            positionBox(113, 865),
            positionBox(1170, 490),
            positionBox(760, 487.5),
            positionBox(351, 679),
            positionBox(313, 413),
            positionBox(297, 841),
            positionBox(105, 423),
            positionBox(970, 435),
            positionBox(376, 615),
            positionBox(206, 706),
        ],
        //threeLeadersEnd,
        [
            positionBox(113, 865),
            positionBox(377, 446),
            positionBox(485, 392),
            positionBox(351, 679),
            positionBox(313, 413),
            positionBox(297, 841),
            positionBox(105, 423),
            positionBox(176, 575),
            positionBox(376, 615),
            positionBox(206, 706),
        ],
        // buildingEnd
        [
            positionBox(975, 515),
            positionBox(975, 515),
            positionBox(975, 515),
            positionBox(975, 515),
            positionBox(975, 515),
            positionBox(975, 515),
            positionBox(975, 515),
            positionBox(975, 515),
            positionBox(975, 515),
            positionBox(975, 515),
        ],
        // circleEnd
        [
            positionBox(113, 865),
            undefined,
            undefined,
            undefined,
            undefined,
            positionBox(297, 841),
            undefined,
            undefined,
            undefined,
            undefined,
        ],
    ];

    let moveLabels = [
        gnosisEnd,
        telescopeEnd,
        lighthouseEnd,
        leadersEnd,
        pathEnd,
        magnifyingGlassEnd,
        threeLeadersEnd,
        buildingEnd,
        circleEnd,
    ];

    onMount(() => {
        timeline.from('.boxG', {
            x: 900,
            y: 600,
            scale: 0,
            duration: 1,
            stagger: 0.1,
        }, 'planetsEnd')

        moveLabels.forEach((label, i) => {
            boxMoves[i].forEach((pos, eye) => {

                if (Boolean(pos)) {
                    const delay = i / 20;
                    const duration = Math.random() * 0.3 + 0.7;

                    mainTimeline.to('.box-' + eye, {
                        ...pos,
                        duration,
                        delay,
                        ease: 'ease-in',
                    }, label);

                    if (i === 7) {
                        mainTimeline.to('.box-' + eye, {
                            motionPath: {
                                path: '.circle-path',
                                end: 1 - eye * 0.03333,
                                align: 'self',
                            },
                            ease: 'ease-out',
                            duration: 3,
                        }, '>');

                        if (eye === 5) {
                            mainTimeline.to('.box-5', {
                                opacity: 0,
                                duration: 0.3
                            }, '<+=0.5')
                        }
                    }

                }
            });
        });

        mainTimeline.to('.box-5', {
            opacity: 1,
            duration: 0.3
        }, circleEnd)

        mainTimeline.to('.boxG', {
            opacity: 0.6,
            scale: 0,
            transformOrigin: 'center'
        }, 'gnosisFinalStart');

        mainTimeline.add(timeline, gnosisStart);
    });

</script>

<foreignObject class="node" x="0" y="0" width="100%" height="1080">
    <body xmlns="http://www.w3.org/1999/xhtml"
          style="--scale-multiplier: {multiplier}; background-color: rgba(0,0,0,0);"
          class:safariAdjustment={isSafari()}>
    <div class="all-boxes">
        {#each boxData as box, i}
            <div style={`transform: translate(${box.x}px, ${box.y}px)`} class={'boxG box-' + i}>
                <Box
                    activeTimes={activeTimes[i]}
                    liftTimes={liftTimes[i]}
                    stopSpinScenes={stopSpinScenes[i]}
                    scene={scene}
                    spinningTimes={spinningTimes}
                    clickableScenes={clickableScenes[i]}
                />
            </div>
        {/each}
    </div>
    </body>
</foreignObject>

<svg x="720px" y="460px">
    <g class="circle-three-times">
        <path class="circle-path"
              d="M250.5,.5c138.07,0,250,121.93,250,260s-111.93,250-250,250S.5,398.57,.5,260.5,112.43,10.5,250.5,10.5s250,111.93,250,250-111.93,250-250,250S.5,398.57,.5,260.5,112.43,10.5,250.5,10.5c138.07,0,250,111.93,250,250s-111.93,250-250,250h0c-138.07,0-250-111.93-250-250S112.43,10.5,250.5,10.5"/>
    </g>
</svg>

<style>
    .safariAdjustment {
        transform: scale(var(--scale-multiplier));
        transform-origin: top left;
    }

    .all-boxes {
        width: 100%;
        height: 100%;
    }

    .boxG {
        position: absolute;
        top: 0;
        left: 0;
    }

    .circle-three-times {
        visibility: hidden;
    }
</style>

